<div class="flex flex-col w-full h-full">
  <!-- File Information Header -->

  @if (viewMode() === 'standard') {
    @if (!dossierFile()) {
      @if (file()) {
        <div class="w-full h-fit">
          <sia-ai-grid-file-information-view
            [file]="file()"
            [showFileName]="showFileName()"
          ></sia-ai-grid-file-information-view>
        </div>
        <mat-tab-group
          class="flex flex-col h-full min-h-0"
          [selectedIndex]="activeTabIndex()"
          (selectedIndexChange)="showPreview.set($event === 0)"
          animationDuration="200ms"
        >
          <mat-tab label="Anteprima">
            <div class="relative w-full h-full p-4">
              <div class="relative w-full h-full rounded-lg surface-low">
                <!-- Removed outer mat-spinner because ai-preview-handler handles its own spinner -->
                <ai-preview-handler
                  [fileType]="file()?.type"
                  [fileSha256]="file()?.sha256 ?? ''"
                  [fileName]="file()?.name ?? ''"
                  [horizontal]="false"
                  (loadingPreview)="loadingPreview.set($event)"
                ></ai-preview-handler>
              </div>
            </div>
          </mat-tab>

          <mat-tab label="File correlati">
            <div class="w-full h-full">
              <related-files-grid
                [file]="file()"
                [(viewMode)]="viewMode"
                [(dossierForUpdate)]="dossier"
                (fileRemovedFromDossier)="fileRemovedFromDossier.emit($event)"
                (fileSelected)="showDossierFilePreview($event)"
              ></related-files-grid>
            </div>
          </mat-tab>
        </mat-tab-group>
      } @else {
        <div class="flex items-center justify-center h-full text-gray-500">
          <span>Seleziona un file per visualizzare i dettagli</span>
        </div>
      }
    } @else {
      <div class="w-full h-fit">
        <sia-ai-grid-file-information-view
          [file]="file()"
          [showFileName]="showFileName()"
        ></sia-ai-grid-file-information-view>
      </div>
      <div class="flex flex-col flex-1 w-full min-h-0 p-4">
        <div
          class="flex w-full flex-row justify-between rounded-t-lg !border-2 border-solid !border-[var(--mat-sys-surface-container-low)] p-2"
        >
          <span class="text-lg text-primary"> {{ dossierFile()?.name }}</span>
          <button mat-icon-button (click)="dossierFile.set(undefined)">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <div
          class="relative flex-1 min-h-0 rounded-lg surface-low"
          [class.rounded-t-none]="dossierFile()"
        >
          <!-- Removed outer mat-spinner because ai-preview-handler handles its own spinner -->
          <ai-preview-handler
            [fileType]="dossierFile()?.type"
            [fileSha256]="dossierFile()?.sha256 ?? ''"
            [fileName]="dossierFile()?.name ?? ''"
            [showFileName]="true"
            [horizontal]="false"
            (loadingPreview)="loadingPreview.set($event)"
          ></ai-preview-handler>
        </div>
      </div>
    }
  } @else {
    <!-- Dossier View Mode -->
    <div class="w-full h-full">
      <related-files-grid
        [file]="file()"
        [(viewMode)]="viewMode"
        [(dossierForUpdate)]="dossier"
        (fileRemovedFromDossier)="fileRemovedFromDossier.emit($event)"
      ></related-files-grid>
    </div>
  }
</div>
